"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _labelConsts = require("01_core/constants/labelConsts");
var _windowUtil = _interopRequireDefault(require("01_core/logics/windowUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _KansaAnswerCondition = _interopRequireDefault(require("./components/KansaAnswerCondition"));
var _KansaAnswerResult = _interopRequireDefault(require("./components/KansaAnswerResult"));
var _kansaAnswerActions = require("./kansaAnswerActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StyledCardContent = (0, _styles.styled)(_material.CardContent)({
  width: '100%'
});
class KansaAnswerMain extends _react.default.Component {
  constructor(props) {
    super(props);
    if (props.shareCondition.init) {
      props.applyCondition(props.shareCondition);
    }
  }
  componentDidMount() {
    const {
      scrollY,
      noSticky
    } = this.props.scrollTop;
    if (noSticky) {
      _windowUtil.default.windowScroll(scrollY);
    } else {
      window.scrollTo(0, 0);
    }
  }
  render() {
    const {
      intl,
      searchResult,
      paging,
      goRefer,
      goRegister,
      resetPaging,
      changePage,
      changeViewNum,
      scrollTop,
      onScroll,
      soshikiShowAll,
      changeShowAll,
      gyomuCd,
      kansaTheme,
      pms,
      search
    } = this.props;

    // 監査回答検索結果一覧の参照アイコン押下ハンドラ
    const onReferClick = kansaInfo => {
      goRefer(kansaInfo);
    };

    // 登録ボタン押下ハンドラ
    const onRegistClick = kansaInfo => {
      goRegister(kansaInfo);
    };
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_KANSA_ANSWER
      })
    }, /*#__PURE__*/_react.default.createElement(StyledCardContent, null, /*#__PURE__*/_react.default.createElement(_KansaAnswerCondition.default, {
      pms: pms
    }), /*#__PURE__*/_react.default.createElement(_KansaAnswerResult.default, {
      onReferClick,
      onRegistClick,
      searchResult,
      paging,
      resetPaging,
      changePage,
      changeViewNum,
      scrollTop,
      onScroll,
      soshikiShowAll,
      changeShowAll,
      kansaTheme,
      gyomuCd,
      search
    })));
  }
}
const mapStateToProps = state => {
  return {
    shareCondition: state.kansaShareCondition,
    searchResult: state.kansaAnswer.searchResult,
    paging: state.kansaAnswer.paging,
    scrollTop: state.kansaAnswer.scrollTop,
    soshikiShowAll: state.kansaAnswer.soshikiShowAll,
    gyomuCd: state.kansaAnswer.fixedConditions.gyomuCd,
    kansaTheme: state.kansaAnswer.fixedConditions.kansaTheme,
    search: state.kansaAnswer.search
  };
};
const mapDispatchToProps = dispatch => {
  return {
    applyCondition: condition => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.APPLY_SHARE_CONDITION](condition)),
    goRefer: userId => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.GO_REFER](userId)),
    goRegister: userId => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.GO_REGISTER](userId)),
    resetPaging: () => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.RESET_PAGING]()),
    changePage: currentPage => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.CHANGE_PAGE](currentPage)),
    changeViewNum: viewNum => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.CHANGE_VIEW_NUM](viewNum)),
    changeShowAll: soshikiShowAll => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.CHANGE_SHOW_ALL](soshikiShowAll)),
    onScroll: scrollTop => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.CHANGE_SCROLL_TOP](scrollTop))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(KansaAnswerMain));